import AccountsListSummary from './AccountsListSummary';

export default AccountsListSummary;
